import CtaButton from '@/components/ui/buttons/CtaButton';
import React from 'react';
import styles from './styles.module.css';
import Value from '@/components/Values/Value';
import { useRouter } from 'next/router';

interface ValuesProps {
  items: string[];
}

const Values: React.FC<ValuesProps> = ({ items }) => {
  const wrapperRef = React.useRef(null);
  const router = useRouter();
  const pathname = router.pathname;
  return (
    <section ref={wrapperRef} className={styles.wrapper}>
      <h2 className={styles.title} style={{ marginBottom: '1rem' }}>
        What We Believe
      </h2>
      <div className={styles.gridContainer}>
        {items && items.length > 0
          ? items.map((item) => (
              <Value key={item} itemKey={item}>
                {item}
              </Value>
            ))
          : null}
      </div>
      {pathname === '/' && (
        <div className={styles.ctaContainer}>
          <CtaButton to="/about/culture" className="cta-primary">
            Why We Do What We Do
          </CtaButton>
        </div>
      )}
    </section>
  );
};

export default Values;
